var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-logo-wrapper"},[_c('img',{attrs:{"src":_vm.url,"alt":"trufflepig"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }